import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "oc-qingcloud",
  "use": "oc-qingcloud-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"oc-qingcloud\"><path d=\"M222.293333 210.218667l0.128 0.426666v334.549334l289.109334 166.997333h0.896l289.109333-166.997333 0.085333-0.426667-0.085333-334.122667 0.085333-0.426666L512.426667 42.666667h-0.896L222.421333 209.792l-0.128 0.426667zM42.666667 981.333333h938.666666v-187.818666H42.666667V981.333333z\" fill=\"#0FA06D\" p-id=\"2781\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol